export default {
  companyName: 'NEURALWORKS STUDIO',
}
